<template>
  <div :class="['logo', { 'logo--invert': invert, [`logo--${size}`]: !!size }]">
    <nuxt-link :to="localePath({ path: '/'})" class="logo__link" :aria-label="$t('NAV_HOME_LABEL')">
      <ShIcon v-if="hasIcon" class="logo__icon" :name="icon" :size="size" />
      <div class="logo__svg" v-html="logo" />
    </nuxt-link>
  </div>
</template>

<script>
import { ShIcon } from '@sohohouse/design-system'
import logoSvg from '~/assets/images/logo.svg'
import logoSvgLight from '~/assets/images/logoLight.svg'

export default {
  components: {
    ShIcon
  },

  props: {
    invert: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'medium'
    },

    hasIcon: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    icon () {
      return this.invert ? 'shLogoInvert' : 'shLogo'
    },

    logo () {
      return this.invert ? logoSvgLight : logoSvg
    }
  }
}
</script>

<style lang="scss" scoped>
$logo-medium: 118px;
$logo-xsmall: 96px;

.logo {
  display: flex;

  ::v-deep svg {
    flex: 1;
    line-height: normal;
  }

  &__svg {
    height: auto;
    width: $space-120;
    display: flex;
    align-items: center;
    justify-items: center;
  }

  &__icon {
    margin: $space-010 $space-030 $space-010 0;
  }

  &__link {
    display: inline-flex;

    &:focus {
      outline: none;
      @include underline();
    }
  }

  &--medium &__svg {
    width: $logo-medium;
  }

  &--xsmall &__svg {
    width: $logo-xsmall;
  }
}
</style>
